module.exports = __webpack_public_path__ + "static/img/home_logo_old.c1b6048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo_old.png
// module id = OK2H
// module chunks = 3